//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventCategorySearchType } from './Enums';

export class EventCategorySearchOptions extends ItemBase {
    SearchText: string | null = null;
    Active: boolean | null = null;
    EventCategoryTypes: EventCategorySearchType[] = [];
    IDs: string[] = [];
    Primary: boolean | null = null;
    Repertoire: boolean | null = null;
    Birthday: boolean | null = null;

    constructor(initializer?: Partial<EventCategorySearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "EventCategorySearchOptions";
}
